import Request from '@/api/request';
import { CommonObject } from '@/utils/types';

export interface CreateAddStDraftPayload {
  originalStatementId: string;
  addStatementType: string;
}

interface DocFile {
  link: string;
  name: string;
  md5: string;
  format?: string;
  guid?: string;
  size?: number;
}

interface AddDocument {
  id: string;
  type: 'QUITTANCE' | 'OTHER';
  name: string;
  date: string;
  issuer: string;
  series: string;
  number: string;
  payerLastname: string;
  payerFirstname: string;
  payerMiddleName: string;
  amount: number;
  oktmo: string;
  accountNum: string;
  accountCorrNum: string;
  bankName: string;
  bik: string;
  file: DocFile;
  fileSig: DocFile;
}

export interface AddStatementDraftResp {
  originalStatementId: string;
  originalStatementType: string;
  originalStatementExtId: string;
  addStatementType: string;
  status: string;
  statusDescription: string;
  id: string;
  xmlLink: string;
  applicant: CommonObject;
  errorString: string;
  documents: AddDocument[];
  /** для EXTRACTION_ROD */
  applicantRole?: string;
}

export interface AddStSaveDocuments {
  id: string;
  documents: AddDocument[];
  changeDescription?: string;
}

export interface SendAddPackageRequest {
  addStatementId: string;
  xmlSigBase64: string;
}

const api = new Request('lk/additional/statement/');

export function getAddStatementById(
  id: string
): Promise<AddStatementDraftResp> {
  return api.get(`getAddStatementById?id=${id}`);
}

export function saveDocuments(payload: AddStSaveDocuments): Promise<void> {
  return api.post('saveDocuments', payload);
}

export function statementXmlBase64(id: string): Promise<string> {
  return api.get(`statementXmlBase64?statementId=${id}`);
}

export function sendPackage(payload: SendAddPackageRequest): Promise<void> {
  return api.post('sendPackage', payload);
}

export function deleteStatementLink(addStatementId: string) {
  return api.delete(`deleteStatementLink?addStatementId=${addStatementId}`);
}

export function createAddStDraft(
  data: CreateAddStDraftPayload
): Promise<AddStatementDraftResp> {
  return api.post('createDraft', data);
}

export function saveAddStDraft(
  data: CommonObject
): Promise<AddStatementDraftResp> {
  return api.post('saveDraft', data);
}
